module.exports = __webpack_public_path__ + "static/media/mgt_civil.ad626e5d.jpg";